import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import PassExampleId from 'shared/images/frontId.webp'
import PassExamplePassport from 'shared/images/frontPassword.webp'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { ImageLazy } from 'shared/ui/image-lazy'

import { Props } from './model'
import s from './styles.module.scss'

export const ScanPage: FC<Props> = ({ openCamera }) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={s.wrapper}>
        <h2 className={clsx(s.scanTitle, 'regular-13')}>
          {t('scan_passport.scan_page_title')}
        </h2>

        <div className={s.infoBlock}>
          <div className={s.text}>
            <h3 className={s.title}>{t('scan_passport.scan_title')}</h3>
            <p className={s.description}>
              {t('scan_passport.scan_description')}
            </p>
          </div>

          <ImageLazy
            alt="passportId"
            src={PassExampleId}
            className={s.image}
          />
        </div>
        <div className={s.infoBlock}>
          <div className={s.text}>
            <h3 className={s.title}>{t('scan_passport.scan_travel_pass')}</h3>
            <p className={s.description}>
              {t('scan_passport.scan_description')}
            </p>
          </div>

          <ImageLazy
            alt="passport"
            src={PassExamplePassport}
            className={s.image}
          />
        </div>
      </div>
      <ButtonContinue onClick={openCamera}>
        <span className={s.buttonText}>{t('scan_passport.scan')}</span>
      </ButtonContinue>
    </div>
  )
}
